import { ArrowRight } from 'lucide-react';

/**
 * MobileAppSplash — interstitial shown to phone/tablet visitors on their first
 * gated page. The native apps aren't out yet, so instead of hard-blocking
 * mobile we show a "Mobile Apps Coming Soon" notice with a one-tap "continue
 * on web" action. Tapping it calls `onContinue`, which persists the choice
 * (see `lib/mobileGate`) so the notice shows once rather than on every
 * navigation.
 */
export function MobileAppSplash({ onContinue }: { onContinue: () => void }) {
  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="mobile-splash-title"
      className="flex min-h-screen flex-col items-center justify-center gap-6 bg-or-cream-50 px-8 text-center"
    >
      <img src="/brand/ollie_logo_square.png" alt="" width={72} height={72} className="shrink-0" />

      <div className="flex max-w-md flex-col gap-3">
        <h1 id="mobile-splash-title" className="font-display text-2xl font-bold text-or-orange-800">
          Mobile Apps Coming Soon
        </h1>
        <p className="text-[15px] leading-relaxed text-or-slate-600">
          Our iOS and Android apps are on the way. In the meantime, you can keep using OllieReads
          right here in your browser.
        </p>
      </div>

      <button
        type="button"
        onClick={onContinue}
        className="or-gradient-btn inline-flex h-12 items-center justify-center gap-2 rounded-full px-6 text-[15px] font-semibold focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-or-orange-500/40"
      >
        Click here to continue on web
        <ArrowRight className="h-5 w-5" aria-hidden />
      </button>
    </div>
  );
}
